<script setup lang="ts">
import { computed } from "vue";
import LanguageDropdown from "@/components/LanguageDropdown.vue";
import { useConfigStore } from "@/stores/store.config";
import { usePageLanguage } from "@/composables/usePageLanguage";

const user = useConfigStore().useUserStore();
const { currentLang, changeLanguage } = usePageLanguage();

const items = computed(() => {
  const languages = user.homepageConfig?.widgetLanguages || [];
  const names = user.homepageConfig?.languageName || {};
  return languages.map((value: string) => ({
    value,
    label: names[value] || value.toUpperCase(),
  }));
});
</script>

<template>
  <div v-if="items.length > 1" class="page-language-switcher">
    <LanguageDropdown
      :items="items"
      :selected="currentLang"
      :aria-label="user.currentLang.labels?.Change_language"
      icon-color="#1F2937"
      @change="changeLanguage"
    />
  </div>
</template>

<style scoped>
.page-language-switcher {
  position: fixed;
  top: 8px;
  inset-inline-end: max(calc((100vw - 425px) / 2 + 8px), 8px);
  z-index: 30;
}
</style>
